<div class="container">

  <div class="title" [matTooltip]="title">{{title}}</div>

  <div class="chip-container" #chipContainer>

    <!-- chip container -->
    <svg *ngIf="dataSource?.length; else noData" width="100%" height="100%" [attr.viewBox]="getViewBoxValue()"
      (wheel)="onZoom($event)">

      <!-- group of chips -->
      <g class="draggable-chips" cdkDrag>
        <ng-container *ngFor="let data of dataSource; let i = index">

          <!-- chip -->
          <svg (click)="chipClicked.emit(data)" [attr.x]="chipX * i" [attr.y]="chipY" [attr.width]="chipWidth"
            [attr.height]="chipHeight">
            <rect [attr.x]="chipBoxX" [attr.y]="chipBoxY" rx="4" ry="4" class="chip-box" />
            <foreignObject [attr.x]="chipBoxX" [attr.y]="chipBoxY" class="chip-box-size">
              <div class="chip-box-text">{{data.name}}</div>
            </foreignObject>
          </svg>

          <!-- connector -->
          <g *ngIf="i > 0" [attr.transform]="getConnectorTransformValue(i)">
            <circle class="connector-dot" cx="0" [attr.cy]="chipBoxMidY" [attr.r]="connectorDotRadius" />
            <line class="connector" [attr.x1]="0" [attr.y1]="chipBoxMidY" [attr.x2]="connectorLen"
              [attr.y2]="chipBoxMidY" />
            <circle class="connector-dot" [attr.cx]="connectorLen" [attr.cy]="chipBoxMidY"
              [attr.r]="connectorDotRadius" />
          </g>
        </ng-container>
      </g>
    </svg>

    <!-- no data -->
    <ng-template #noData>
      <div class="no-data">No data found!</div>
    </ng-template>

  </div>
</div>